import { Component, Input, OnInit } from '@angular/core';
import {
  Roles,
  UserAttributes,
} from '../../../authentication/data-access/models/auth.model';
import { NavigationEnd, Router } from '@angular/router';
import { RouteEnum } from '../../enums/routes';
import { AdditionaInfoMessageType } from '../../enums/messages';
import { UserStore } from '../../data-access/stores/user.store';
import { Observable } from "rxjs";
import { AuthService } from "../../../authentication/data-access/services/auth.service";
import { AcademicLookupService } from '../../data-access/services/academic-lookup.service';

@Component({
    selector: 'app-shared-menu',
    templateUrl: './shared-menu.component.html',
    styleUrl: './shared-menu.component.scss',
    standalone: false
})
export class SharedMenuComponent implements OnInit {
  isLoggedIn$: Observable<boolean> = this.authService.isLoggedIn$;
  @Input() menuTrigger!: string;
  @Input() label!: string;
  @Input() userDetails!: UserAttributes;
  currentRoute!: string;
  departments!: string[];
  menuItems: any[] = [];
  isLoading = true;
  isDean: boolean = false;
  rolesEnum = Roles;
  darkNavBarRoutes = [
    '/',
    '/unauthorised',
    '/forbidden',
    '/not-found',
    '/application/student/bursaryInformation',
    '/student/application/success',
    '/student/application/renewal/success',
  ];

  constructor(
    private router: Router,
    private userStore: UserStore,
    private authService: AuthService,
    private academicLookupService: AcademicLookupService,
  ) {
    this.currentRoute = this.router.url;
    this.router.events.subscribe(() => {
      this.currentRoute = this.router.url;
    });
  }

  ngOnInit(): void {
    this.userStore.get().subscribe((user) => {
      this.userDetails = user;
      this.getDepartmentMenuItems();
    })
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.urlAfterRedirects;
      }
    });
    this.isDean = this.userStore.hasRole([this.rolesEnum.DEAN]);
  }
  isHomeRoute(): boolean {
    return this.currentRoute === '/';
  }

  darkNavBar(): boolean {
    const regex = new RegExp(/^\/student\/application\/success(\/\d+|\/renewal\/\d+)?$/);
    return regex.test(this.currentRoute);
  }

  navigate(item: { route: string; queryParams?: { tab: number } }) {
  this.router.navigate([item.route], {
    queryParams: item.queryParams,
  });
}
  getMenuItems() {
    if (this.isDean) {
        return this.menuItems.length != 0
          ? this.menuItems.map((departments) => {
              const department = departments.universityDepartmentName;
              return {
                label: department,
                route: `dashboard/departments/${department}`,
              };
            })
          : [
              {
                label: AdditionaInfoMessageType.NO_DEPARTMENTS_MESSAGE,
                route: this.router.url,
              },
            ];
    } else {
        return [
          {
            label: 'Bursaries',
            route: RouteEnum.HodDashboardBursaries,
            queryParams: { tab: 0 },
          },
          {
            label: 'Applications',
            route: RouteEnum.HodDashboardApplication,
            queryParams: { tab: 1 },
          },
        ];
    }
  }

  getDepartmentMenuItems(): void {
    if (this.userDetails) {
      this.academicLookupService.getDepartments(this.userDetails.university, this.userDetails.faculty).subscribe((departments) => {
          if (departments) {
            this.menuItems = departments;
            if (this.menuItems) this.isLoading = false;
          }
        });
    }
  }
  trackByFn(index: number, item: any): any {
    return item.route;
  }
}
